import { render, staticRenderFns } from "./VR.vue?vue&type=template&id=a6b8cb32&scoped=true&"
import script from "./VR.vue?vue&type=script&lang=js&"
export * from "./VR.vue?vue&type=script&lang=js&"
import style0 from "./VR.vue?vue&type=style&index=0&id=a6b8cb32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b8cb32",
  null
  
)

export default component.exports